import React, { useEffect, useState } from 'react'
import { Box, Container, Typography, useTheme, useMediaQuery } from '@mui/material';
import Loader from '../component/Loader/Loader';
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { getAllClassesOfStudent } from '../helper/student_helper';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const localizer = momentLocalizer(moment);

const LiveClasses = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [liveClasses, setLiveClasses] = useState([]);
    const [loader, setLoader] = useState(false);
    const navigate = useNavigate();

    const fetchClasses = async () => {
        try {
            setLoader(true);
            const id = JSON.parse(localStorage.getItem('student'))?.id;
            const data = await getAllClassesOfStudent(id);
            if (data?.success) {
                const lvClass = data?.result?.map((liveClass) => ({
                    title: liveClass.title,
                    start: new Date(liveClass.classTime),
                    end: new Date(liveClass.classTime),
                    description: liveClass.description,
                    classLink: liveClass.classLink,
                }));
                setLiveClasses(lvClass);
            } else {
                toast.error(data?.message || "Something went wrong");
            }
        } catch (error) {
            console.error('Error fetching classes:', error);
        } finally {
            setLoader(false);
        }
    };

    useEffect(() => {
        fetchClasses();
    }, [])

    useEffect(() => {
        // Check if 'student' exists in localStorage
        const student = localStorage.getItem('student');

        // If 'student' is not found, navigate to the login page
        if (!student) {
            navigate('/login');
        }
    }, [navigate]);

    return (
        <>
            {loader ? (
                <Loader />
            ) : ("")}

            <Container maxWidth="xl" sx={{ py: { xs: 2, md: 4 } }}>
                <Typography 
                    variant={isMobile ? "h4" : "h3"} 
                    component="h1" 
                    align="center" 
                    sx={{ mb: 3, fontWeight: 600 }}
                >
                    Live Classes
                </Typography>

                <Box sx={{ height: { xs: 'calc(100vh - 140px)', md: '600px' } }}>
                    <Calendar
                        localizer={localizer}
                        events={liveClasses}
                        startAccessor="start"
                        endAccessor="end"
                        defaultView="month"
                        views={["month", "day"]}
                        style={{
                            height: "100%",
                            backgroundColor: "#f0f0f0",
                            borderRadius: "8px",
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
                        }}
                        eventPropGetter={() => ({
                            style: {
                                backgroundColor: "#357edd",
                                color: "white",
                                padding: isMobile ? "3px" : "5px",
                                borderRadius: "4px",
                                fontSize: isMobile ? "12px" : "14px",
                            }
                        })}
                        popup={true}
                        onSelectEvent={(event) => window.open(event.classLink, "_blank", "noopener,noreferrer")}
                    />
                </Box>
            </Container>
        </>
    )
}

export default LiveClasses
